import Pattern from "../../assets/HeadingSectionPattern.svg"

const SupportHeader = () => {
    return (
        <div className="bg-[#c7461f] relative md:mt-20 mt-[60px] min-h-[435px]">
        <img src={Pattern} className="absolute w-full h-full object-cover" alt="" />
        <div className="container z-50 relative h-full flex lg:flex-row flex-col items-center py-12 lg:gap-14 md:gap-10 gap-6">
            <div className="lg:w-[60%] w-full text-white">
                <h1 className="font-semibold lg:text-start text-center lg:text-5xl md:text-4xl sm:text-3xl text-2xl  mb-7">
                Welcome to Our Support Center!
                </h1>
                <p className="mb-8 lg:text-start text-center md:text-lg sm:text-base text-sm max-w-4xl mx-auto">
                We're here to help you! If you have any questions, concerns, or need assistance, feel free to reach out to our support team through the chat below. Our dedicated support agents are available to provide you with the information and help you need.
                </p>

            </div>
            <div className="bg-white rounded-xl md:px-6 px-3 md:py-9 py-5 lg:w-[40%] w-full min-h-80">
                <h1 className="mb-3 text-primary sm:text-[28px] text-2xl font-semibold">How to use Chat</h1>
<div className="space-y-1" >
    <h1 className="font-medium text-textPrimary sm:text-base text-sm">
    <b>1.Start a Conversation:</b> Simply type your message in the chat box and hit send. Our support team will respond as quickly as possible.
    </h1>
    <h1 className="font-medium text-textPrimary sm:text-base text-sm">
    <b>2.Ask Questions:</b> Whether you have inquiries about our services, need help with an issue, or want to provide feedback, we’re here to listen.
    </h1>
    <h1 className="font-medium text-textPrimary sm:text-base text-sm">
    <b>3.Attachments:</b> If you need to share any files or screenshots, you can easily upload them through the chat interface.
    </h1>
    <h1 className="font-medium text-textPrimary sm:text-base text-sm">
    <b>4.Stay Updated:</b> You can view the status of your previous tickets and ongoing conversations right here in the chat.
    </h1>
</div>
            </div>
        </div>
    </div>
);
  };
  
  export default SupportHeader;
  